<script>
    import { about_panel_state, doc } from "./util/stores.js"
    import Dropdown from './util/Dropdown.svelte'

    let pages = ['Plot','Setting','Characters']
    let selected_cat = [$doc['current_page'] == 'Plot' ? 'selected' : '', $doc['current_page'] == 'Setting' ? 'selected' : '', $doc['current_page'] == 'Characters' ? 'selected' : '']

    let unit_menu_buttons = ['pages','minutes','paragraphs','chapters','books']
    let unit_menu_dropdown = false
    let files_menu_buttons = ['Import', 'Export', 'Settings']
    let files_menu_dropdown = false

    function ChangeWorkingPage(page){
        pages.forEach((p,i) => {
            if(p == page){
                selected_cat[i] = 'selected'
                //document.getElementById(p).classList.add('selected')
            }else{
                selected_cat[i] = ''
                //document.getElementById(p).classList.remove('selected')
            }
        })

        $doc.current_page = page
        console.log("Changed working page to " + page)
    }

    function UpdateDoc(prop, val){
        if(typeof(val) == "object"){
            $doc[prop] = val.target.value
            console.log("Changed doc :"+prop+": to " + val.target.value)
        }else{
            $doc[prop] = val
            console.log("Changed doc :"+prop+": to " + val)
        }
    }

    function RestrictNumber(val, min, max){
        if(typeof(val) == "object"){
            val = parseInt(val.target.value)
            val = val > max ? val < min ? min : max : val
        }else if(typeof(val) == 'number'){
            val = val > max ? val < min ? min : max : val
        }else if(typeof(val) == 'string'){
            val = parseInt(val)
            val = val > max ? val < min ? min : max : val
        }
        return val
    }

</script>

<div class="nav sections">
    <div class="brand"> <div class="logo"></div> avenoir</div>

    <div class="menu">
        <div class="menu_flex">
            <button type="button" id="files_menu_dropdown" on:focus={() => {files_menu_dropdown = true}} on:blur={() => {setTimeout(()=>{files_menu_dropdown = false}, 100)}}>
                <img src="../pics/icons/Files_icon.svg" style="pointer-events: none;" alt="file menu button">
            </button>
            <button type="button" on:click={() => {about_panel_state.set(true)}}>
                <img src="../pics/icons/About_icon.svg" style="pointer-events: none;" alt="about/info button">
            </button>
            <Dropdown options={files_menu_buttons} show={files_menu_dropdown} type='menu' height='131px' button_id='files_menu_dropdown' auto_width={true}></Dropdown>
        </div>
    </div>

    <div class="doc_info">
        <input type="text" class="doc_title" placeholder="Untitled" on:blur={(val) => {UpdateDoc("title", val)}}/>
        <span>|</span>
        <input type="number" class="unit_count" placeholder="00" value={$doc.units} on:blur={(val) => {UpdateDoc("units", RestrictNumber(val.target.value, 0, 999))}}/>
        
        <button class="units" id="unit_menu_dropdown" on:focus={() => {unit_menu_dropdown = true}} on:blur={() => {setTimeout(()=>{unit_menu_dropdown = false}, 100)}}> <!--on:blur={() => {unit_menu_dropdown = false}}-->
            {$doc['unit_type']}
        </button>
        <Dropdown options={unit_menu_buttons} selected_callback={(unit) => {$doc['unit_type'] = unit; }} show={unit_menu_dropdown} type='units' height='219px' button_id='unit_menu_dropdown'></Dropdown>
    </div>

    <div class="categories">
        <button class="{selected_cat[0]}" id="Plot" on:click={() => {ChangeWorkingPage("Plot")}}>Plot</button>
        <span>•</span>
        <button class="{selected_cat[1]}" id="Setting" on:click={() => {ChangeWorkingPage("Setting")}}>Setting</button>
        <span>•</span>
        <button class="{selected_cat[2]}" id="Characters" on:click={() => {ChangeWorkingPage("Characters")}}>Characters</button>
    </div>

    <!--
    <div class="share">
        <div class="share_flex">
            <button type="button">Share</button>

            
                <div type="button" class="profile">
                <div class="pic"></div>
                 <img src="../pics/icons/arrow_icon.svg" class="arrow"> --> <!--
            </div>
            
        </div>
    </div>-->
</div>


<style lang="scss">
@use "./styles/global.scss";

.nav{
    position: relative;
    z-index: 10;

    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

    /*
    width: 100vw;
    height: 48px;
    
    display: flex;
    justify-content: space-between;
    vertical-align: middle;
    */

    display: grid;
    grid-template-columns: $logo_width 102px auto auto; //10%
    grid-template-rows: $nav_bar_h;
    grid-template-areas: "logo buttons doc_info categories"; //share

    align-items: center;
    justify-items: center;
}

.sections{
    font: inherit;
    font-size: 18px;
    line-height: 21px;

    button{
        border: none;
        cursor:pointer;
        background-color: white;
    }

    .brand{
        //width: 80%;
        margin-left: 40px;
        margin-right: 40px;

        line-height: 28px;
        font-size: 24px;

        grid-area: logo;

        display: flex;
        flex-direction: row;
        justify-content: center; //space-evenly
        align-items: center;

        .logo{
            width: 32px;
            height: 32px;
            background-image: url('../pics/icons/avenoir_logo.svg');
            background-size: 32px 32px;

            margin-right: 8px;
        }
    }

    .menu{
        grid-area: buttons;
        justify-self: start;

        .menu_flex{
            display: flex;
            flex-direction: row;
            justify-content: start;

            button{
                @include purple_button;
                width: 48px;
                height: 48px;

                margin: 0px;
                padding: 0px;
                margin-right: 6px;
            }
        }
    }

    .doc_info{
        $shadow: rgba(0,0,0,0.1);
        $shadow_size: 5px;

        grid-area: doc_info;
        display: flex;
        justify-content: center;
        align-items: center;

        height: 100%;

        .doc_title{
            @include input_text_no_style;

            padding: 0;
            margin: 0;
            resize: horizontal;
            min-width: fit-content;
            width: 100%;
            height: 100%;

            text-align: end;
            color: black;
        }

        span{
            margin-left: 8px;
            margin-right: 8px;
            color: $grey5;
        }

        .unit_count{
            @include input_num_no_style;
            font-size: 14px;
            width: 2rem;
            height: 60%;
            border-radius: 6px;
            padding-left: 8px;
            padding-right: 8px;

            transition: .3s;

            &:hover{
                -moz-box-shadow:     0 0 $shadow_size $shadow;
                -webkit-box-shadow:  0 0 $shadow_size $shadow;
                box-shadow:          0 0 $shadow_size $shadow;
            }
        }
        
        .units{
            width: 200px;
            height: 60%;
            border-radius: 6px;
            padding-left: 8px;
            padding-right: 8px;

            &:hover{
                -moz-box-shadow:     0 0 $shadow_size $shadow;
                -webkit-box-shadow:  0 0 $shadow_size $shadow;
                box-shadow:          0 0 $shadow_size $shadow;
            }
        }
    }

    .categories{
        grid-area: categories;

        width: auto;
        height: auto;
        display: flex;
        justify-content: space-around;

        button{
            font-style: italic;
            font-weight: thin;
            font-size: 16px;
            line-height: 21px;

            color: $grey3;
            outline: none;

            transition: 0.3s;

            &:hover{
                color: $accent_purple;
            }
        }

        .selected{
            color: $accent_purple;
        }

        span{
            margin-left: 0.3vw;
            margin-right: 0.3vw;

            color: $grey5;
        }
    }

    /*
    .share{
        grid-area: share;
        padding: 0px;
        margin: 0px;

        .share_flex{
            display: flex;
            flex-direction: row;
            justify-content: space-around;

            button{
                @include purple_button;
                border-radius: 3px;

                width: 57px;
                height: 26px;

                font-size: 14px;
                line-height: 16px;
            }

            .profile{
                width: 42px;
                height: 26px;
                background-color: transparent;
                position: relative;

                .pic{
                    border-radius: 13px;

                    width: 26px;
                    height: 26px;

                    font-size: 14px;
                    line-height: 16px;

                    color: white;
                    background-color: $accent_orange;
                }

                .arrow{
                    transform: rotate(90deg);
                    color: black;
                }
            }
        }

    }
    */
}

</style>